import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import FileUpload from './FileUpload'
import { axiosInstance } from '../../../../const/axiosInstance'
import styles from './edit.module.css'

export default function EditLibrary({add}) {
    const [library, setLibrary] = useState({})
    const [image, setImage] = useState('')

    const {id} = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            if(!add){
                const res = await axiosInstance.get(`/use/library/${id}`)
                if(res.data.status){
                    setLibrary(res.data.data)
                    setImage(res.data.data.image)
                }
            }
            })()
    },[])

    useEffect(() => {
        setLibrary(prev => ({...prev, image}))
    }, [image])

    const addLibrary = async () => {
        await axiosInstance.post(`/admin/library/add`, library)
        navigate("/dashboard/library")
    }

    const editLibrary = async () => {
        await axiosInstance.post(`/admin/library/edit`, library)
        navigate("/dashboard/library")
    }

  return (
    <div className={styles['edit-part']}>
        <div className={styles['upload']}>
            <p>{add ? 'Ավելացնել' : 'Փոխել'} նկարը։ </p>
            <FileUpload setImage={setImage}/>  
            <input disabled={true} placeholder='ֆայլ' value={image}/>
        </div>
        <div className={styles['btn-div']}>
            {
                    !image ? <button disabled className={`${styles['btn']} ${styles['confirm']}`}>Հաստատել</button>
                    :
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={add ? addLibrary : editLibrary}>Հաստատել</button>}
            <Link to='/dashboard/library'><button className={`${styles['btn']} ${styles['cancel']}`}>Չեղարկել</button></Link>
        </div>
    </div>
  )
}
